import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
import { AlertService } from '../../services/Alert/alert.service';
import { ApiService } from '../../services/API/api.service';
import { HttpErrorResponse } from '@angular/common/http';
import 'owl.carousel'; 

@Component({
  selector: 'app-home-page-two',
  templateUrl: './home-page-two.component.html',
  styleUrls: ['./home-page-two.component.scss']
})
export class HomePageTwoComponent implements OnInit {

  menuItems: any[] = []

  offers: any[] = [];

  constructor(private alertService: AlertService,private apiService: ApiService) { }

  showSuccess() {
    this.alertService.success('Operation completed successfully!');
  }

  showError() {
    this.alertService.danger('Something went wrong!');
  }

  ngOnInit(): void {
    this.getData()
    this.getHomePageSubCategory()
    this.getAllCategories()
  }

  showCarousel: boolean = false;
  getData() {
    this.apiService.getHomePageData().subscribe({
      next: response => {
        this.offers = response.data.ads;
      }, 
      error: (error: HttpErrorResponse) => {
        console.log(error);
        this.alertService.danger('Something went wrong!');
      }
    });
  }

  lunchCategoryId: any[] = []
  cateringCategoryId: any[] = []
  data: any
  cateringImage: string = ''
  lunchImage: string = ''
  getAllCategories(){
    this.apiService.getAllCategories().subscribe({
      next: response => {
        this.data = response.data
        this.cateringImage = this.data[1].avatar
        this.lunchImage = this.data[0].avatar
        this.lunchCategoryId = response.data.map(category => (category.name == 'Lunch' || category.name == 'Launch') == true ? category.id : null).filter(Boolean);
        this.cateringCategoryId = response.data.map(category => (category.name == 'Catering') == true ? category.id : null).filter(Boolean);
        // console.log(this.cateringCategoryId[0])
      }, 
      error: (error: HttpErrorResponse) => {
        console.log(error);
        this.alertService.danger('Something went wrong!');
      }
    });
  }

  getHomePageSubCategory(){
    this.apiService.getHomePageSubCategory().subscribe({
      next: response => {
        this.menuItems = response.data;
      }, 
      error: (error: HttpErrorResponse) => {
        console.log(error);
        this.alertService.danger('Something went wrong!');
      }
    });
  }

  lunchMenuItems: boolean = false
  cateringMenuItems: boolean = false
  showMenu(menu: string) {
    if(menu === 'lunch'){
      $('.lunchMenuItems-cateringMenuItems').addClass('d-none');
      $('.lunchMenuItems').removeClass('d-none');
      $('.cateringMenuItems').addClass('d-none');
      this.lunchMenuItems = true;
      this.cateringMenuItems = false;
    }
    else if(menu === 'catering'){
      $('.lunchMenuItems-cateringMenuItems').addClass('d-none');
      $('.cateringMenuItems').removeClass('d-none');
      $('.lunchMenuItems').addClass('d-none');
      this.cateringMenuItems = true;
      this.lunchMenuItems = false;
    }
  }

  showLunchCatringMenu(){
    $('.lunchMenuItems-cateringMenuItems').removeClass('d-none');
    $('.cateringMenuItems').addClass('d-none');
    $('.lunchMenuItems').addClass('d-none');
    this.lunchMenuItems = false;
    this.cateringMenuItems = false;
  }

  chunkArray(arr: any[], size: number): any[] {
    const chunks = [];
    for (let i = 0; i < arr.length; i += size) {
      chunks.push(arr.slice(i, i + size));
    }
    return chunks;
  }

  // Function to calculate empty cells
  getEmptyCells(row: any[]): any[] {
    return Array(5 - row.length).fill(null);
  }
}
